import Library from "../../resources/mobile/ru/Library.json" 
import aboutWidgetTranslate from "../../resources/mobile/ru/aboutWidgetTranslate.json" 
import addComment from "../../resources/mobile/ru/addComment.json" 
import addPage from "../../resources/mobile/ru/addPage.json" 
import addPageLinks from "../../resources/mobile/ru/addPageLinks.json" 
import addPageLocation from "../../resources/mobile/ru/addPageLocation.json" 
import advancedSearchTranslate from "../../resources/mobile/ru/advancedSearchTranslate.json" 
import authorHeader from "../../resources/mobile/ru/authorHeader.json" 
import basicPreviewTemplate from "../../resources/mobile/ru/basicPreviewTemplate.json" 
import bestRelated from "../../resources/mobile/ru/bestRelated.json" 
import calendar from "../../resources/mobile/ru/calendar.json" 
import channelWidget from "../../resources/mobile/ru/channelWidget.json" 
import chats from "../../resources/mobile/ru/chats.json" 
import collectionWidget from "../../resources/mobile/ru/collectionWidget.json" 
import commentsPreview from "../../resources/mobile/ru/commentsPreview.json" 
import companyAdder from "../../resources/mobile/ru/companyAdder.json" 
import companyType from "../../resources/mobile/ru/companyType.json" 
import confirmReadingTranslate from "../../resources/mobile/ru/confirmReadingTranslate.json" 
import contactAdder from "../../resources/mobile/ru/contactAdder.json" 
import contactInput from "../../resources/mobile/ru/contactInput.json" 
import contactPicker from "../../resources/mobile/ru/contactPicker.json" 
import contactSearchBox from "../../resources/mobile/ru/contactSearchBox.json" 
import contactWidget from "../../resources/mobile/ru/contactWidget.json" 
import currentGroup from "../../resources/mobile/ru/currentGroup.json" 
import customInputViewTemplate from "../../resources/mobile/ru/customInputViewTemplate.json" 
import dataTypeWidget from "../../resources/mobile/ru/dataTypeWidget.json" 
import dataTypesTranslate from "../../resources/mobile/ru/dataTypesTranslate.json" 
import datePickerTranslate from "../../resources/mobile/ru/datePickerTranslate.json" 
import drawer from "../../resources/mobile/ru/drawer.json" 
import dueDate from "../../resources/mobile/ru/dueDate.json" 
import editCustomInputTranslate from "../../resources/mobile/ru/editCustomInputTranslate.json" 
import favouritesKanbanTranslate from "../../resources/mobile/ru/favouritesKanbanTranslate.json" 
import favouritesTableTranslate from "../../resources/mobile/ru/favouritesTableTranslate.json" 
import favouritesWidgetTranslate from "../../resources/mobile/ru/favouritesWidgetTranslate.json" 
import feed from "../../resources/mobile/ru/feed.json" 
import feedPreviewItems from "../../resources/mobile/ru/feedPreviewItems.json" 
import filterView from "../../resources/mobile/ru/filterView.json" 
import fullview from "../../resources/mobile/ru/fullview.json" 
import groupLabelTranslate from "../../resources/mobile/ru/groupLabelTranslate.json" 
import inputTypes from "../../resources/mobile/ru/inputTypes.json" 
import itemHeaderMenu from "../../resources/mobile/ru/itemHeaderMenu.json" 
import itemPreviewCommentsBarTranslate from "../../resources/mobile/ru/itemPreviewCommentsBarTranslate.json" 
import lastActivitiesInGroup from "../../resources/mobile/ru/lastActivitiesInGroup.json" 
import lastModifiedDaysAlertTranslate from "../../resources/mobile/ru/lastModifiedDaysAlertTranslate.json" 
import linkedDocument from "../../resources/mobile/ru/linkedDocument.json" 
import locationAdderTranslate from "../../resources/mobile/ru/locationAdderTranslate.json" 
import locationEditTranslate from "../../resources/mobile/ru/locationEditTranslate.json" 
import locationInputTranslate from "../../resources/mobile/ru/locationInputTranslate.json" 
import locationSearchBox from "../../resources/mobile/ru/locationSearchBox.json" 
import locationTypesTranslate from "../../resources/mobile/ru/locationTypesTranslate.json" 
import locationWidget from "../../resources/mobile/ru/locationWidget.json" 
import mustReadTranslate from "../../resources/mobile/ru/mustReadTranslate.json" 
import newItem from "../../resources/mobile/ru/newItem.json" 
import newItemTranslate from "../../resources/mobile/ru/newItemTranslate.json" 
import openHelp from "../../resources/mobile/ru/openHelp.json" 
import orgCharts from "../../resources/mobile/ru/orgCharts.json" 
import pollTemplate from "../../resources/mobile/ru/pollTemplate.json" 
import postInput from "../../resources/mobile/ru/postInput.json" 
import postInputComponentTranslate from "../../resources/mobile/ru/postInputComponentTranslate.json" 
import quickActionButton from "../../resources/mobile/ru/quickActionButton.json" 
import reportsView from "../../resources/mobile/ru/reportsView.json" 
import results from "../../resources/mobile/ru/results.json" 
import searchAutoComplete from "../../resources/mobile/ru/searchAutoComplete.json" 
import searchTranslate from "../../resources/mobile/ru/searchTranslate.json" 
import snackbarTranslate from "../../resources/mobile/ru/snackbarTranslate.json" 
import suggestedNews from "../../resources/mobile/ru/suggestedNews.json" 
import taskDetailTranslate from "../../resources/mobile/ru/taskDetailTranslate.json" 
import titlePreviewTemplateFull from "../../resources/mobile/ru/titlePreviewTemplateFull.json" 
import userGroupsTranslate from "../../resources/mobile/ru/userGroupsTranslate.json" 
import userPage from "../../resources/mobile/ru/userPage.json" 
import userSettingsTranslate from "../../resources/mobile/ru/userSettingsTranslate.json" 

export const ru = {
	Library, 
	aboutWidgetTranslate, 
	addComment, 
	addPage, 
	addPageLinks, 
	addPageLocation, 
	advancedSearchTranslate, 
	authorHeader, 
	basicPreviewTemplate, 
	bestRelated, 
	calendar, 
	channelWidget, 
	chats, 
	collectionWidget, 
	commentsPreview, 
	companyAdder, 
	companyType, 
	confirmReadingTranslate, 
	contactAdder, 
	contactInput, 
	contactPicker, 
	contactSearchBox, 
	contactWidget, 
	currentGroup, 
	customInputViewTemplate, 
	dataTypeWidget, 
	dataTypesTranslate, 
	datePickerTranslate, 
	drawer, 
	dueDate, 
	editCustomInputTranslate, 
	favouritesKanbanTranslate, 
	favouritesTableTranslate, 
	favouritesWidgetTranslate, 
	feed, 
	feedPreviewItems, 
	filterView, 
	fullview, 
	groupLabelTranslate, 
	inputTypes, 
	itemHeaderMenu, 
	itemPreviewCommentsBarTranslate, 
	lastActivitiesInGroup, 
	lastModifiedDaysAlertTranslate, 
	linkedDocument, 
	locationAdderTranslate, 
	locationEditTranslate, 
	locationInputTranslate, 
	locationSearchBox, 
	locationTypesTranslate, 
	locationWidget, 
	mustReadTranslate, 
	newItem, 
	newItemTranslate, 
	openHelp, 
	orgCharts, 
	pollTemplate, 
	postInput, 
	postInputComponentTranslate, 
	quickActionButton, 
	reportsView, 
	results, 
	searchAutoComplete, 
	searchTranslate, 
	snackbarTranslate, 
	suggestedNews, 
	taskDetailTranslate, 
	titlePreviewTemplateFull, 
	userGroupsTranslate, 
	userPage, 
	userSettingsTranslate, 
}